"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ENV_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _siteHeader.ENV_SHAPE_PROP_TYPE;
  }
});
Object.defineProperty(exports, "REQUEST_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _siteHeader.REQUEST_SHAPE_PROP_TYPE;
  }
});
Object.defineProperty(exports, "USER_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _siteHeader.USER_SHAPE_PROP_TYPE;
  }
});
exports.FOOTER_LINKS_SHAPE_PROP_TYPE = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _siteFooter = require("@eb/site-footer");

var _siteHeader = require("@eb/site-header");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FOOTER_LINKS_SHAPE_PROP_TYPE = _propTypes.default.shape({
  popularSearches: _siteFooter.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  eventsToPlan: _siteFooter.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumn: _siteFooter.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  countries: _siteFooter.COUNTRIES_ARRAY_PROP_TYPE.isRequired,
  showMinimalLinks: _propTypes.default.bool,
  thirdFooterColumnName: _propTypes.default.string.isRequired
});

exports.FOOTER_LINKS_SHAPE_PROP_TYPE = FOOTER_LINKS_SHAPE_PROP_TYPE;
//# sourceMappingURL=constants.js.map